import React, { Component } from 'react';
import {  Redirect } from "react-router-dom";
import { MCbrowser } from '../Context/browserContext'; 
import App from "../Controllers/App";

class Auth extends Component{

    constructor(props) {
        super(props);
        this.props=props;
    }

    render(){ 
        let isLogined=this.context.isLoggedIn;
        if(isLogined===true){
            return (
                <App  logout={this.props.logout} />
            )
        }else{
            return (
                <Redirect to="/auth/login" />
            )
        }
    }
} 
Auth.contextType = MCbrowser;
export default Auth;